import { render, staticRenderFns } from "./SectionChat.vue?vue&type=template&id=143dc10e&"
import script from "./SectionChat.vue?vue&type=script&lang=js&"
export * from "./SectionChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports